import { Container, Row, Col } from 'react-bootstrap';
import { SignupForm } from '../../../Components/forms/signupform/SignupForm';
import signupImage from '../../../assets/images/signup.jpg';
import logo from '../../../assets/images/logo.png';
import './signup.css';

export const Signup = () => {
  const handleSignup = (data) => {
    console.log('Signup data:', data);
    // TODO: connect to API
  };

  return (
    <div className="signup-page">
      <Container fluid className="h-100 p-0">
        <Row className="signup-row g-0">
          {/* Left — image panel */}
          <Col xs={12} md={6} className="signup-image-col d-none d-md-block">
            <img
              src={signupImage}
              alt="Medical professionals"
              className="signup-side-image"
            />
          </Col>

          {/* Right — form panel */}
          <Col xs={12} md={6} className="signup-form-col">
            <div className="signup-form-container">
              <img src={logo} alt="Bizaario Care" className="signup-logo" />
              <SignupForm onSubmit={handleSignup} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
